import { PolicyInfoResponse } from 'all-in-one-shared-api/dist/apis/policy/PolicyInfoResponse';

import { DEFAULT_DATE_FORMAT, formatDateString } from 'utils/datetime';

export const FALLBACK_YEAR_RANGE = '1900-1901';

export const getLatestPolicyYearRange = (
  policyInfoData: PolicyInfoResponse[] | undefined,
  memberType: string,
  renewalNumber: number,
): string => {
  if (!policyInfoData) return '';

  const policy = policyInfoData.find((i) => i.renewalNumber === renewalNumber && i.memberType === memberType);

  if (policy) {
    const startYear = formatDateString(policy?.startDate ?? '', 'yyyy');
    const endYear = formatDateString(policy?.endDate ?? '', 'yyyy', DEFAULT_DATE_FORMAT);
    return `${startYear}-${endYear}`;
  }

  return FALLBACK_YEAR_RANGE;
};
